import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPieChart3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="pie-chart-3, graph, statistics"><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><path d="M12 3V12L18 18" stroke="currentColor" strokeWidth="1.5"/><path d="M12 12.0001L20.5 8.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconPieChart3;
